var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pay-wait",staticStyle:{"background-color":"#e6f0f5"}},[_c('div',{staticClass:"order_success order_success_o"},[_c('p',[_c('span',{attrs:{"id":"count"}},[_vm._v(_vm._s(_vm.count))]),_vm._v("正等待微信返回结果...\n      ")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3689ae06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pay/payWeixinWait.vue
// module id = null
// module chunks = 